import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_BLOCK_DATE_LIST, GET_BLOCK_DATE_LIST_SUCCESS, GET_BLOCK_DATE_LIST_ERROR } from '../../actions';
import apiCall from '../../../apiCall';

function* getBlockDateList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { facilityId } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/golf-inventory/block-date/listing?facilityId=${facilityId}&page_size=10&page_index=0`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BLOCK_DATE_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BLOCK_DATE_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BLOCK_DATE_LIST_ERROR, payload: error });
  }
}

export function* watchgetBlockDateList() {
  yield takeEvery(GET_BLOCK_DATE_LIST, getBlockDateList);
}

function* getBlockDateListSaga() {
  yield all([fork(watchgetBlockDateList)]);
}

export default getBlockDateListSaga;
